const SidechainStatus = {
	created: 0,
	confirmed: 1,
};
export default SidechainStatus;
